module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"finish_button":"Bewertung abschließen","success":"Feedback erfolgreich gesendet.","error":"Beim Senden des Feedbacks ist ein Fehler aufgetreten."},"en":{"finish_button":"Finish evaluation","success":"Feedback successfully submitted.","error":"An error occured while submitting the feedback."}}')
  delete Component.options._Ctor
}
